import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {Subject} from '@node_modules/rxjs/internal/Subject';
import {MatDialog} from '@node_modules/@angular/material';
import {TermsComponent} from '@components/terms/terms.component';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';
import * as moment from '@node_modules/moment';
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
  static source;
  static sourceSchedule = null;
  static repeatable = false;
  static setData = false;
  static insertedObject: any;
  static direction: string;
  static students_in_program: number;
  static methodDelete: string;
  static methodDeleteParam: any;
  static methodCancel: string;
  static methodCancelParam: any;
  static methodDeleteAllParam: any;
  static methodDeleteAll: string;
  static modalRef: any;
  static withButtons = true;
  static withInputNumber = false;
  static inputNumberValue = 0;
  static maxInputNumberValue;
  static minInputNumberValue = 1;
  static textModal;
  static titleModal;
  static textButton;
  static actionButtonClass = '';
  static cancelButtonClass = '';
  static withSelectedDayString = false;
  static direction_delete_program = 'delete_program';
  static cancelButtonText = '';
  static hideCancel = false;
  static resetProperties() {
    ConfirmModalComponent.source = null;
    ConfirmModalComponent.sourceSchedule = null;
    ConfirmModalComponent.withInputNumber = false;
    ConfirmModalComponent.inputNumberValue = 0;
    ConfirmModalComponent.repeatable = false;
    ConfirmModalComponent.setData = false;
    ConfirmModalComponent.insertedObject = null;
    ConfirmModalComponent.direction = null;
    ConfirmModalComponent.students_in_program = null;
    ConfirmModalComponent.methodDelete = null;
    ConfirmModalComponent.methodDeleteParam = null;
    ConfirmModalComponent.methodDeleteAllParam = null;
    ConfirmModalComponent.methodDeleteAll = null;
    ConfirmModalComponent.modalRef = null;
    ConfirmModalComponent.withButtons = true;
    ConfirmModalComponent.hideCancel = false;
    ConfirmModalComponent.textModal = null;
    ConfirmModalComponent.titleModal = null;
    ConfirmModalComponent.textButton = null;
    ConfirmModalComponent.actionButtonClass = '';
    ConfirmModalComponent.cancelButtonClass = '';
    ConfirmModalComponent.direction_delete_program = 'delete_program';
    ConfirmModalComponent.methodCancel = '';
    ConfirmModalComponent.methodCancelParam = '';
    ConfirmModalComponent.cancelButtonText = '';
  };
  title;
  monthsNumber: Subject<any> = new BehaviorSubject(null);
  moveMonthsCarousel: BehaviorSubject<string> = new BehaviorSubject(null);
  insertingSchedule: Subject<any> = new BehaviorSubject<any>(null);
  repeatable = false;
  daySelected = false;
  source = 'delete';
  studentsNumber;
  currentMonth = new Date().getMonth() + 1;
  currentYear = new Date().getFullYear();
 selectedDayString: BehaviorSubject<string> = new BehaviorSubject(null);
  agreement;
  months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  constructor(
      public dialog: MatDialog,
  ) { }
  ngOnInit() {
    this.title = ConfirmModalComponent.titleModal ? ConfirmModalComponent.titleModal : 'Please choose when you will start';
    this.source = ConfirmModalComponent.source;
    this.repeatable = ConfirmModalComponent.repeatable;
    this.studentsNumber = ConfirmModalComponent.students_in_program;
    if (this.isWithData() && ConfirmModalComponent.sourceSchedule) {
      this.insertingSchedule.next(ConfirmModalComponent.sourceSchedule);
    }
  }
  // checkAgreement() {
  //   return ConfirmModalComponent.agreement;
  // }
  ngOnDestroy() {
    this.resetProperties();
  }
  getCancelMethod() {
    return ConfirmModalComponent.methodCancel;
  }
  cancel() {
    if (ConfirmModalComponent.methodCancel) {
      ConfirmModalComponent.insertedObject[ConfirmModalComponent.methodCancel](ConfirmModalComponent.methodCancelParam);
    }
  }
  close() {
    // console.log(ConfirmModalComponent);
    if (ConfirmModalComponent.modalRef) {
      ConfirmModalComponent.modalRef.close();
    }
    // this.resetProperties();
  }
  getCancelButtonText() {
    return ConfirmModalComponent.cancelButtonText;
  }
  getActionButtonClass() {
    return ConfirmModalComponent.actionButtonClass;
  }
  getCancelButtonClass() {
    return ConfirmModalComponent.cancelButtonClass;
  }
  actionDelete() {
    // console.log("0000000000000000");
    if (this.repeatable === true) {
      ConfirmModalComponent.insertedObject[ConfirmModalComponent.methodDelete](ConfirmModalComponent.methodDeleteParam, ConfirmModalComponent.methodDeleteAllParam);
    } else {
      // console.log(ConfirmModalComponent.insertedObject, ConfirmModalComponent.methodDelete, ConfirmModalComponent.methodDeleteParam);
      ConfirmModalComponent.insertedObject[ConfirmModalComponent.methodDelete](ConfirmModalComponent.methodDeleteParam);
    }
    console.log(ConfirmModalComponent);
    ConfirmModalComponent.modalRef.close();
  }
  actionDeleteAll() {
    ConfirmModalComponent.insertedObject[ConfirmModalComponent.methodDeleteAll](ConfirmModalComponent.methodDeleteParam);
    ConfirmModalComponent.modalRef.close();
  }
  isProgramDirectionWithForce() {
    return ConfirmModalComponent.direction === ConfirmModalComponent.direction_delete_program && ConfirmModalComponent.methodDeleteParam &&
        ConfirmModalComponent.methodDeleteParam.force && ConfirmModalComponent.methodDeleteParam.force === true;
  }
  getAsk() {
    // console.log(this);
    this.agreement = false;
    switch (this.source) {
      case 'subscribe': {
        this.agreement = true;
        return 'Subscribe to the program?';
      }
      case 'unsubscribe': {
        return 'Unsubscribe to the program?';
      }
      case 'resend_request': {
        return 'Resend request?';
      }
      case 'send_request': {
        return 'Send request?';
      }
      case 'need_charge': {
        return  ConfirmModalComponent.textModal;
      }
      case 'info': {
        return  ConfirmModalComponent.textModal;
      }
      case 'stop_subscription': {
        this.agreement = true;
        return  ConfirmModalComponent.textModal ? ConfirmModalComponent.textModal : 'Stop subscription?';
      }
      case 'continue_subscription': {
        return  ConfirmModalComponent.textModal;
      }
      case 'deleteProgram': {
        return  ConfirmModalComponent.textModal;
      }
      case 'toggle_subscription': {
        return  ConfirmModalComponent.textModal;
      }
      case 'teacher_subscription': {
        return  ConfirmModalComponent.textModal;
      }
      default: {
        return  ConfirmModalComponent.textModal;
      }
    }
  }
  getButtonTitle() {
    switch (this.source) {
      case 'deleteProgram': {
        return 'Delete';
      }
      case 'subscribe': {
        return 'Subscribe';
      }
      case 'unsubscribe': {
        return 'Unsubscribe';
      }
      case 'resend_request': {
        return 'Resend';
      }
      case 'send_request': {
        return 'Send';
      }
      case 'need_charge': {
        return 'Go to pay';
      }
      case 'stop_subscription': {
        return ConfirmModalComponent.textButton;
      }
      case 'continue_subscription': {
        return 'Continue';
      }
      case 'toggle_subscription': {
        return  ConfirmModalComponent.textButton;
      }
      case 'pause_teacher_subscription': {
        return  'Pause';
      }
      default: {
        return  ConfirmModalComponent.textButton ?  ConfirmModalComponent.textButton  : 'Delete';
      }
    }
  }
  onMonthToRight() {
    this.currentMonth -= 1;
    // console.log(this.currentMonth, 'right');
    if (this.currentMonth < 1) {
      this.currentYear--;
      this.currentMonth = 12;
    }
    this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
    this.moveMonthsCarousel.next('right');
  }
  onMonthToLeft() {
    this.currentMonth += 1;
    // console.log(this.currentMonth, 'left');
    if (this.currentMonth > 12) {
      this.currentYear++;
      this.currentMonth = 1;
    }
    this.monthsNumber.next({month: this.currentMonth, year: this.currentYear});
    this.moveMonthsCarousel.next('left');
  }
  onSelectedDay(event) {
    // console.log(event);
    if (event.schedules && event.schedules.length > 0) {
      ConfirmModalComponent.methodDeleteParam.startDay = +event.day;
      ConfirmModalComponent.methodDeleteParam.startMonth = +event.month;
      ConfirmModalComponent.methodDeleteParam.startYear = this.currentYear;
      this.daySelected = true;
    } else {
      this.daySelected = false;
    }
    if (ConfirmModalComponent.withSelectedDayString) {
        this.selectedDayString.next(moment().date(event.day).month(event.month - 1).year(this.currentYear).format('ll'));
        this.daySelected = true;
    }
  }
  isWithData() {
    return ConfirmModalComponent.setData === true;
  }
  isHideCancel() {
    return ConfirmModalComponent.hideCancel;
  }
  hasTitle() {
    return !!ConfirmModalComponent.titleModal;
  }
  isWithButtons() {
    const conditionOne = ConfirmModalComponent.withButtons === true;
    if (this.isWithData()) {
      return conditionOne && (ConfirmModalComponent.withInputNumber ? true : this.daySelected);
    }
    return conditionOne;
  }
  resetProperties() {
    ConfirmModalComponent.source = null;
    ConfirmModalComponent.sourceSchedule = null;
    ConfirmModalComponent.withInputNumber = false;
    ConfirmModalComponent.inputNumberValue = 0;
    ConfirmModalComponent.repeatable = false;
    ConfirmModalComponent.setData = false;
    ConfirmModalComponent.insertedObject = null;
    ConfirmModalComponent.direction = null;
    ConfirmModalComponent.students_in_program = null;
    ConfirmModalComponent.methodDelete = null;
    ConfirmModalComponent.methodDeleteParam = null;
    ConfirmModalComponent.methodDeleteAllParam = null;
    ConfirmModalComponent.methodDeleteAll = null;
    ConfirmModalComponent.modalRef = null;
    ConfirmModalComponent.withButtons = true;
    ConfirmModalComponent.textModal = null;
    ConfirmModalComponent.titleModal = null;
    ConfirmModalComponent.textButton = null;
    ConfirmModalComponent.direction_delete_program = 'delete_program';
    ConfirmModalComponent.methodCancel = '';
    ConfirmModalComponent.methodCancelParam = '';
    ConfirmModalComponent.cancelButtonText = '';
    ConfirmModalComponent.hideCancel = false;
  }
  // statusChanged(event) {
  //   console.log(event);
  //   console.log(event.target);
  //   console.log(event.parentNode);
  //   if (event.checked === true) {
  //     event.target.parentNode.classList.add('active');
  //   } else {
  //     event.target.parentNode.classList.remove('active');
  //   }
  // }
  openDialog() {
    const reference = this.dialog.open(TermsComponent);
    TermsComponent.modalRef = reference;
  }

  withInputNumber() {
      return ConfirmModalComponent.withInputNumber;
  }

  getInputNumberValue() {
     return ConfirmModalComponent.inputNumberValue;
  }
  updateInputNumberValue(event) {
      let number = Math.round(event.target.valueAsNumber);
      if (!isNaN(number)) {
          if ( number < 1) {
              number = 1;
          }
          if (ConfirmModalComponent.maxInputNumberValue &&  number > ConfirmModalComponent.maxInputNumberValue) {
              number = ConfirmModalComponent.maxInputNumberValue;
          }
          ConfirmModalComponent.inputNumberValue = number;
          event.target.value = number;
          if (ConfirmModalComponent.methodDeleteParam && ConfirmModalComponent.methodDeleteParam.amount) {
              ConfirmModalComponent.methodDeleteParam.amount = number;
          }
      }
  }
  getMaxInputNumberValue() {
      return ConfirmModalComponent.maxInputNumberValue;
  }
  getMinInputNumberValue() {
      return ConfirmModalComponent.minInputNumberValue;
  }
  isWithSelectedDayString() {
    return ConfirmModalComponent.withSelectedDayString;
  }
}
